import "./Footer.css";
export default function Footer() {
	return (
		<>
			<footer>
				<p className='rights'>
					&copy; {new Date().getFullYear()} Motorschirm Pfalz Rundflug. Alle
					Rechte vorbehalten.
				</p>
				<div className='footerWrapper'>
					<a
						href='/impressum'
						style={{
							color: "#555",
							textDecoration: "underline",
							margin: "0 5px",
						}}>
						Impressum
					</a>{" "}
					<a
						href='/datenschutz'
						style={{
							color: "#555",
							textDecoration: "underline",
							margin: "0 5px",
						}}>
						Datenschutz
					</a>{" "}
					<a
						href='/agb'
						style={{
							color: "#555",
							textDecoration: "underline",
							margin: "0 5px",
						}}>
						AGB
					</a>
				</div>
			</footer>
		</>
	);
}
